import { render, staticRenderFns } from "./IconRightArrowMenu.vue?vue&type=template&id=249d3adc&"
import script from "./IconRightArrowMenu.vue?vue&type=script&lang=js&"
export * from "./IconRightArrowMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports